/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- EXTERNAL PAGE ID CONFIGS - SENTIMENT CONFIGS : STYLES --------------- ++++++++++ */
export default {
    externalpageidconfig: {
        '& .name-pageidmessage': {
            marginTop: pxToEm(35)
        }
    }
};
